import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f99eb6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ef-notifications" }
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ef-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wip" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person-digging" }),
    /*#__PURE__*/_createTextVNode(" WORK IN PROGRESS ")
  ])
], -1))

import Header from '@/components/Header.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, {
        icone: "fa-solid fa-bell",
        title: "Notifications"
      })
    ]),
    _hoisted_3
  ]))
}
}

})